import React from "react";
import { AuthProvider } from "./context/authContext";
import { ThemeProvider } from "./context/themeContext";
import { Route, Routes, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ToastProvider } from "./components/Toast";
import PageTransition from "./components/PageTransition";
import AmbientBackground from "./components/AmbientBackground";
import VinylPlayer from "./components/VinylPlayer";

// Import all pages
import Layout from "./layouts/Layout";
import Home from "./pages/Home";
import Blogs from "./pages/Blogs";
import BlogItem from "./pages/BlogItem";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Login from "./pages/Login";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  const location = useLocation();

  const disableAnimations =
    typeof process !== "undefined" &&
    process.env &&
    process.env.REACT_APP_DISABLE_ANIMATIONS === "true";

  const withTransition = (element) => {
    if (disableAnimations) return element;
    return <PageTransition>{element}</PageTransition>;
  };

  return (
    <ThemeProvider>
      <ToastProvider>
        <AuthProvider>
          {/* Outside keyed Routes so ambient + audio survive page navigation */}
          <AmbientBackground />
          <VinylPlayer />
          <AnimatePresence mode="wait" initial={false}>
            <Routes location={location} key={location.pathname}>
              <Route element={<Layout />}>
                {/* Public Routes */}
                <Route path="/" element={withTransition(<Home />)} />
                <Route path="/blogs" element={withTransition(<Blogs />)} />
                <Route path="/blogs/:id" element={withTransition(<BlogItem />)} />
                <Route path="/about" element={withTransition(<About />)} />
                <Route path="/projects" element={withTransition(<Projects />)} />
                <Route path="/contact" element={withTransition(<Contact />)} />
                <Route path="/login" element={withTransition(<Login />)} />

                {/* Protected Routes */}
                <Route element={<ProtectedRoute />}>
                  <Route
                    path="/admin-dashboard"
                    element={withTransition(<AdminDashboard />)}
                  />
                </Route>

                {/* 404 Route */}
                <Route path="*" element={withTransition(<NotFound />)} />
              </Route>
            </Routes>
          </AnimatePresence>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
